import { render, staticRenderFns } from "./CtaTwo.vue?vue&type=template&id=4fa2c905&scoped=true"
import script from "./CtaTwo.vue?vue&type=script&lang=js"
export * from "./CtaTwo.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4fa2c905",
  null
  
)

/* custom blocks */
import block0 from "./CtaTwo.vue?vue&type=custom&index=0&blockType=i18n"
if (typeof block0 === 'function') block0(component)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {AppStoreLinks: require('/vercel/path0/components/blocks/AppStoreLinks.vue').default,CImage: require('/vercel/path0/components/ui/c-image.vue').default})
